var _defs, _polygon, _polygon2, _path, _line, _line2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaubis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 158.39 138.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#36a9e1;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "111.38 1.5 47.01 1.5 1.5 39.28 1.5 102.44 47.01 136.73 111.38 136.73 156.89 102.44 156.89 39.28 111.38 1.5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "136.53 69.11 79.2 116.23 21.87 69.11 79.2 21.12 136.53 69.11"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.09,201.45c0,9.87-14,15.67-23.09,15.67-10.17,0-23.09-5.8-23.09-15.67S187.25,179,200,179,223.09,191.58,223.09,201.45Z",
    transform: "translate(-120.8 -130.88)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 66.38,
    y1: 62.49,
    x2: 75.5,
    y2: 66.63
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.01,
    y1: 62.49,
    x2: 82.89,
    y2: 66.63
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.5,204.29c-3.5.69-4.54-.61-7.5-.61s-4,1.3-7.5.61",
    transform: "translate(-120.8 -130.88)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaubis);
export default __webpack_public_path__ + "static/media/caubis.d41a813686ec6add734a0a4a6aa6aa0c.svg";
export { ForwardRef as ReactComponent };